import { render, staticRenderFns } from "./CheckoutPlanBox.vue?vue&type=template&id=15892b1a&scoped=true"
import script from "./CheckoutPlanBox.vue?vue&type=script&lang=js"
export * from "./CheckoutPlanBox.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPlanBox.vue?vue&type=style&index=0&id=15892b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15892b1a",
  null
  
)

export default component.exports